import SendDocumentDialog from 'components/Dialog/SendDocumentDialog/SendDocumentDialog';
import { useMutateInspection } from 'hooks/Inspections/InspectionsHooks';
import React, { useState } from 'react';
import { ImageListType } from 'react-images-uploading';
import { toast } from 'react-toastify';
import DocumentService from 'services/DocumentService/documentService';
import { IUploadDocumentsDialogProps } from './UploadDocumentsDialog.types';
import { DocumentCategoryEnum } from '../Inspection/Inspection.types';

const UploadDocumentsDialog = ({
  dialogVisibility,
  inspection,
  inspectionDocuments,
  handleClose,
}: IUploadDocumentsDialogProps) => {
  const [loading, setLoading] = useState(false);
  const { invalidateInspectionParallel } = useMutateInspection();

  const getTotalDocumentsWithOriginUploadKite = (): number | undefined => {
    return inspectionDocuments?.filter((document) => document.origin === 'UPLOAD_KITE').length;
  };

  const handleSubmit = async (onImageRemoveAll: () => void, documents: ImageListType) => {
    try {
      const totalDocuments = getTotalDocumentsWithOriginUploadKite() || 0;
      setLoading(true);
      const s3Documents = await DocumentService.uploadDocuments(
        inspection.id,
        documents,
        totalDocuments,
        DocumentCategoryEnum.REPORT
      );
      toast.success('Documento enviado com sucesso, em breve, você poderá visualizar-lo.');
      onImageRemoveAll();
      setLoading(false);
      invalidateInspectionParallel(inspection.id);
      handleClose();
    } catch (error) {
      setLoading(false);
      toast.error('Falha ao enviar documento.');
    }
  };

  return (
    <SendDocumentDialog
      title="Enviar documento"
      subtitle="Para realizar o atendimento, envie os documentos clicando abaixo"
      textDragAndDrop="Clique ou arraste o arquivo aqui"
      errorMessage="* Tipo de arquivo não suportado"
      btnSubmitText="ENVIAR"
      dialogVisibility={dialogVisibility}
      extensions={['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpg', 'jpeg', 'png']}
      replaceTooltipIcon="Substituir documento"
      removeTooltipIcon="Remover documento"
      loadingButton={loading}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      testId="send-document-dialog"
    />
  );
};

export default UploadDocumentsDialog;
